import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/services/mobileRecharge/recharge.css";
import {
  indaneGasOpCode,
  operartorsUrl,
  bharatGasOpCode,
  hpGasOpCode,
} from "../../../constants";
import RecentHistory from "../../../components/services/RecentHistory";
import { lpgGasServiceId, googleAnalytics } from "../../../constants";

import ReactGA from "react-ga";
import { Loading, MuiSnackBar, ThemeButton } from "../../../components/common";
import { fetchLPGBill, getInputFieldsByOperator } from "../../../redux/slices/services/LpgGasSlice";
import { useDispatch, useSelector } from "react-redux";
import { getOperatorsByServiceId } from "../../../redux/slices/services/servicesSlice";

ReactGA.initialize(googleAnalytics);

const LpgGasFront = ({ props }) => {
  // const [operatorsList, setOperatorList] = useState([]);
  const [mobileNo, setMobileNo] = useState("");
  const [selectedOperator, setSelectedOperator] = useState("");
  const [selectedOperatorId, setSelectedOperatorId] = useState("");

  const [opImgUrl, setOpImgUrl] = useState("");
  const [showBill, setShowBill] = useState(false);
  const [billFetchData, setBillFetchData] = useState({});
  const [operatorPaymentMode, setOperatorPaymentMode] = useState("");
  const [billFetchError, setBillFetchError] = useState("");
  // const [loading, setLoading] = useState(false);
  const [isSnackBar, setIsSnackBar] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [billAmount, setBillAmount] = useState(0);
  const [inputFields, setInputFields] = useState([]);
  const [isClick, setIsClick] = useState(false)
  //indane gas states
  const [selectDropDownValue, setSelectDropDownValue] = useState(
    "Distributor Code And Consumer Number"
  );
  const [consumerNumber, setConsumerNumber] = useState("");
  const [distribuationCode, setDistribuationCode] = useState();
  let dropDownValue = [
    "Distributor Code And Consumer Number",
    "LPG ID",
    "Mobile Number",
  ];

  let navigate = useNavigate();
const dispatch= useDispatch()
const { loggedInUser } = useSelector(
  state => state.loginSlice.loggetInWithOTP
);
const { operatorsList } = useSelector(state => state.servicesSlice.operators );
const { operatorData } = useSelector(state => state.fastagSlice.inputFieldOperator );
const { billData,loading } = useSelector(state => state.LpgGasSlice.lpgBill );
  const getTodaysDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formatedToday = mm + "/" + dd + "/" + yyyy;

    return formatedToday;
  };

  const callInputFields = (ourCode) => {
    setIsClick(true)
    dispatch(getInputFieldsByOperator(ourCode))
  };

  const pushInArray = (searchKey, data) => {
    let keyIndex = inputFields.findIndex(function (element) {
      return element.fieldName === searchKey;
    });

    if (keyIndex !== -1) {
      inputFields[keyIndex].fieldValue = data;
    } else {
      inputFields.push({
        fieldName: searchKey,
        fieldValue: data,
        regex: "",
        validate: true,
      });
    }
  };

  const handleAllFieldInput = (e, index) => {
    setBillFetchError("");
    setShowBill(false);
    let data = [...inputFields];

    data[index].fieldValue = e.target.value.toUpperCase();

    const regex = RegExp(data[index].regex);
    if (!e.target.value.match(regex)) {
      inputFields[index].validate = false;
    } else {
      inputFields[index].validate = true;
    }

    setInputFields(data);
  };

  const handleOperatorSelection = (e, o) => {
    setShowBill(false);
    setSelectedOperator(o.OperatorName);
    setOpImgUrl(o.Image);
    setSelectedOperatorId(o.OurCode);
    setInputFields([]);
    setConsumerNumber("");
    setMobileNo("");
    setDistribuationCode("");
    if (o.PaymentMode == 1 || o.PaymentMode == 3) {
      callInputFields(o.OurCode);
    }

    setOperatorPaymentMode(o.PaymentMode);
  };

  const clickFetchBill = (e) => {
    e.preventDefault();
    setBillFetchError("");

    if (selectedOperatorId === indaneGasOpCode) {
      if (selectDropDownValue === "Distributor Code And Consumer Number") {
        if (consumerNumber) {
          pushInArray("ConsumerNumber", consumerNumber);
          pushInArray("Number", consumerNumber);
        } else {
          setErrorSnackBar("Please enter consumer number");
          return;
        }

        if (distribuationCode) {
          pushInArray("DistributorId", distribuationCode);
        } else {
          setErrorSnackBar("Please enter DistributorId");
          return;
        }
        if (mobileNo) {
          pushInArray("MobileNumber", mobileNo);
        } else {
          setErrorSnackBar("Please enter mobile number");
          return;
        }
      } else if (selectDropDownValue === "LPG ID") {
        if (mobileNo) {
          pushInArray("LPGId", consumerNumber);
        } else {
          setErrorSnackBar("Please enter LPG Id");
          return;
        }
        if (consumerNumber) {
          pushInArray("Number", consumerNumber);
        } else {
          setErrorSnackBar("Please enter consumer number");
          return;
        }

        if (mobileNo) {
          pushInArray("MobileNumber", mobileNo);
        } else {
          setErrorSnackBar("Please enter mobile number");
          return;
        }
        pushInArray("RegisteredMobNo", mobileNo);
      } else {
        if (mobileNo) {
          pushInArray("Number", mobileNo);
          pushInArray("MobileNumber", mobileNo);
          pushInArray("RegisteredMobNo", mobileNo);
        } else {
          setErrorSnackBar("Please enter mobile number");
          return;
        }
      }
    } else if (selectedOperatorId === bharatGasOpCode) {
      if (consumerNumber) {
        pushInArray("Number", consumerNumber);
      } else {
        setErrorSnackBar("Please enter consumer number");
        return;
      }

      if (mobileNo) {
        pushInArray("MobileNumber", mobileNo);
      } else {
        setErrorSnackBar("Please enter mobile number");
        return;
      }

      pushInArray("RegisteredMobNo", mobileNo);
    } else {
      if (consumerNumber) {
        pushInArray("ConsumerNumber", consumerNumber);
        pushInArray("Number", consumerNumber);
      } else {
        setErrorSnackBar("Please enter consumer number");
        return;
      }

      if (distribuationCode) {
        pushInArray("DistributorId", distribuationCode);
      } else {
        setErrorSnackBar("Please enter Distribator ID");
        return;
      }

      if (mobileNo) {
        pushInArray("MobileNumber", mobileNo);
      } else {
        setErrorSnackBar("Please enter Mobile Number");
        return;
      }
    }

    if (selectedOperator) {
      if (mobileNo && mobileNo.length === 10) {
        let validateBBPSField = inputFields.filter((o) => o.validate === false);
        if (validateBBPSField.length !== 0) {
          setErrorSnackBar(
            `Please enter valid ${validateBBPSField[0].fieldName}`
          );
        } else {
          // setLoading(true);
          const obj = inputFields.reduce(
            (arr, curr) => ({ ...arr, [curr.fieldName]: curr.fieldValue }),
            {}
          );
          obj.MobileNumber = mobileNo;
          obj.OperatorCode = selectedOperatorId;
          obj.Ip = "123";
dispatch(fetchLPGBill({obj,username:loggedInUser.Mobile,password:loggedInUser.TRXNPassword}))
        }
      } else {
        setErrorSnackBar("Enter Valid Mobile Number");
      }
    } else {
      setErrorSnackBar("Please Select Operator");
    }
  };
  useEffect(() => {
if(loggedInUser){
  ReactGA.pageview(window.location.pathname);
  dispatch(getOperatorsByServiceId("33"))
}else{
navigate("/login")
}
  }, [props]);
  
  useEffect(() => {
    if(billData.ResponseStatus===1){
      if(billData.Data.ResponseMessage==="Successful"){
     setShowBill(true);
                   setBillFetchData(billData.Data);
                   setBillAmount(parseFloat(billData.Data.BillAmount));
   }else{
     setBillFetchError(billData.Data.ResponseMessage);
   }
   }else if(billData.ResponseStatus===0){
     setIsSnackBar(true)
     setErrorMsg(billData.Remarks)
   }
  }, [billData])
  const handleMobileNo = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setMobileNo(value);
    setBillFetchError("");
  };

  const handleAmount = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setIsSnackBar(false);
    setBillAmount(value);
  };

  const setErrorSnackBar = (msg) => {
    setIsSnackBar(true);
    setErrorMsg(msg);
  };

  const sortOperator = (operators) => {
    let sortedOperators = operators.sort((a, b) =>
      a.OperatorName > b.OperatorName ? 1 : -1
    );
    return sortedOperators;
  };

  const onClickContinue = (e) => {
    if (billAmount && billAmount > 0) {
      navigate(`/services/LPG/confirm`, {
        state: {
          billData: billFetchData,
          number: mobileNo,
          operator: selectedOperator,
          operatorId: selectedOperatorId,
          amount: billAmount,
          inputFieldsData: inputFields,
        },
      });
    } else {
      setIsSnackBar(true);
      setErrorMsg("Please enter valid amount");
    }
  };

  const handleConsumerNumber = (e) => {
    setBillFetchError("");
    setConsumerNumber(e.target.value);
  };

  const handleDitribuationCode = (e) => {
    setBillFetchError("");
    setDistribuationCode(e.target.value);
  };

  const mobileNumberTextField = () => (
    <div class="row">
      <div class="col-lg-12 electricity-bill-field p-0">
        <div class="form-group input-group input-field">
          <span class="input-group-prepend">
            <div class="input-group-text">+91</div>
          </span>
          <input
            onChange={handleMobileNo}
            value={mobileNo}
            id="electricity-bill-user"
            class="mobile-input"
            type="tel"
            placeholder="&nbsp;"
            autoComplete="off"
            minLength={10}
            maxLength={10}
          />
          <label for="electricity-bill-user"> Mobile Number </label>
        </div>
      </div>
    </div>
  );
  //Indane Gas

  const indaneGas = () => (
    <>
      <div class="row">
        <div class="col-lg-12 p-0">
          <div class="dropdown select-option ">
            <button
              className={
                "dropdown-toggle select-toggle select-type" +
                (selectDropDownValue ? "Active" : "")
              }
              value={selectDropDownValue}
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <span class="dropdown-text-limit">
                {selectDropDownValue ? selectDropDownValue : "Select Value"}
              </span>
            </button>
            <div class="dropdown-menu">
              {dropDownValue &&
                dropDownValue.map((o, i) => (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectDropDownValue(o);
                      setBillFetchError("");
                      setShowBill(false);
                    }}
                    type="button"
                    class="dropdown-item"
                  >
                    {o}
                  </a>
                ))}
            </div>
          </div>
        </div>
      </div>
      {getIndaneGasFields()}
    </>
  );

  const getBharatGasFields = () => (
    <>
      {consumerField()}
      {mobileNumberTextField()}
    </>
  );

  const getHPGasFields = () => <>{distribuatorTextFields()}</>;

  const getIndaneGasFields = () => (
    <>
      {selectDropDownValue === "Mobile Number" ? (
        mobileNumberTextField()
      ) : selectDropDownValue === "LPG ID" ? (
        <>
          {consumerField()}
          {mobileNumberTextField()}
        </>
      ) : (
        distribuatorTextFields()
      )}
    </>
  );

  const distrubationField = () => (
    <>
      <div class="row">
        <div class="col-lg-12 mobile-recharge-field p-0">
          <div class="input-field">
            <input
              onChange={(e) => {
                handleDitribuationCode(e);
              }}
              name={distribuationCode}
              placeholder="&nbsp;"
              id="referral-mobile"
              type="text"
              required
            />
            <label for="referral-mobile">Distributor Code</label>
          </div>
          {/* { !inputFields[i].validate ? <ErrorText error={`Please enter valid ${inputFields[i].fieldName}`} /> : null } */}
        </div>
      </div>
    </>
  );

  const consumerField = () => (
    <>
      <div class="row">
        <div class="col-lg-12 mobile-recharge-field p-0">
          <div class="input-field">
            <input
              onChange={(e) => {
                handleConsumerNumber(e);
              }}
              name={consumerNumber}
              placeholder="&nbsp;"
              id="referral-mobile"
              type="text"
              required
            />
            <label for="referral-mobile">Consumer Number</label>
          </div>
        </div>
      </div>
    </>
  );

  const distribuatorTextFields = () => (
    <>
      {distrubationField()} {consumerField()} {mobileNumberTextField()}
    </>
  );

  const showBillFetchError = () => (
    <div className="mt-3">
      {billFetchError && (
        <div className="alert alert-danger">{billFetchError}</div>
      )}
    </div>
  );

  const fetchBillSection = () => (
    <div>
      <div class="row">
        <div class="col-lg-12 electricity-bill-field p-0">
          <div class="accordion" id="electricitybilldetails">
            <div class="item">
              <div class="item-header" id="headingOne">
                <div class="accordion-title">
                  <button
                    class="btn btn-link"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Consumer Details
                    <i class="fa fa-angle-down"></i>
                  </button>
                </div>
              </div>
              <div
                id="collapseOne"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#electricitybilldetails"
              >
                <div class="accordion-content">
                  <div class="row flex-position">
                    <div class="col-sm-6">
                      <label class="accordion-content-left-text"> Name:</label>
                    </div>
                    <div class="col-sm-6 accordion-content-text">
                      <label class="accordion-content-right-text">
                        {billFetchData.CustomerName}{" "}
                      </label>
                    </div>
                  </div>

                  {billFetchData.CustomerParamsDetails &&
                    billFetchData.CustomerParamsDetails.map((data, i) => (
                      <div class="row flex-position">
                        <div class="col-sm-6">
                          <label class="accordion-content-left-text">
                            {" "}
                            {data.Name} :
                          </label>
                        </div>
                        <div class="col-sm-6 accordion-content-text">
                          <label class="accordion-content-right-text">
                            {data.Value}
                          </label>
                        </div>
                      </div>
                    ))}

                  <div class="row flex-position">
                    <div class="col-sm-6">
                      <label class="accordion-content-left-text">
                        {" "}
                        Bill Date :
                      </label>
                    </div>
                    <div class="col-sm-6 accordion-content-text">
                      <label class="accordion-content-right-text">
                        {billFetchData.BillDate}
                      </label>
                    </div>
                  </div>

                  <div class="row flex-position">
                    <div class="col-sm-6">
                      <label class="accordion-content-left-text">
                        {" "}
                        Bill Due Date :
                      </label>
                    </div>
                    <div class="col-sm-6 accordion-content-text">
                      <label class="accordion-content-right-text">
                        {billFetchData.BillDueDate}
                      </label>
                    </div>
                  </div>

                  {billFetchData.AdditionalDetails &&
                    billFetchData.AdditionalDetails.map((data, i) => (
                      <div class="row flex-position">
                        <div class="col-sm-6">
                          <label class="accordion-content-left-text">
                            {" "}
                            {data.Name} :
                          </label>
                        </div>
                        <div class="col-sm-6 accordion-content-text">
                          <label class="accordion-content-right-text">
                            {data.Value}
                          </label>
                        </div>
                      </div>
                    ))}

                  {billFetchData.BillDetails &&
                    billFetchData.BillDetails.map((data, i) => (
                      <div class="row flex-position">
                        <div class="col-sm-6">
                          <label class="accordion-content-left-text">
                            {" "}
                            {data.Name} :
                          </label>
                        </div>
                        <div class="col-sm-6 accordion-content-text">
                          <label class="accordion-content-right-text">
                            &#x20B9; {data.Value}
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {amountField()}
    </div>
  );

  const amountField = () => (
    <div class="row">
      <div class="col-lg-12 electricity-bill-field p-0">
        <div class="input-field">
          <input
            onChange={handleAmount}
            id="referral-mobile"
            value={billAmount > 0 ? billAmount : ""}
            type="text"
            placeholder="&nbsp;"
            autoComplete="off"
            maxLength={7}
            minLength={1}
            required
          />
          <label for="referral-mobile"> Amount </label>
        </div>
      </div>
    </div>
  );

  const rechargeSection = () => (
    <div>
      <section class="inpage-section-align mobile-recharge">
        <div class="container">
          <div class="row">
            {/*<!-- mobile recharge start --> */}

            <div class="col-sm-12 col-md-12 col-lg-5 mobile-recharge-left">
              {/* {<div class="mobile-recharge-left">} */}
              <div class="mob-left-sticky box-shadow-1">
                <div class="row">
                  <div class="col-md-12 mobile-recharge-content-head">
                    <h3 class="mobile-recharge-title"> Pay LPG Bill </h3>
                  </div>
                </div>

                <form>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-lg-12 p-0">
                        <div class="dropdown select-option ">
                          <button
                            className={
                              "dropdown-toggle select-toggle select-type" +
                              (selectedOperator ? "Active" : "")
                            }
                            value={selectedOperator}
                            type="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span class="dropdown-text-limit">
                              {" "}
                              {selectedOperator
                                ? selectedOperator
                                : "Operator"}{" "}
                            </span>
                          </button>
                          <div class="dropdown-menu">
                            {operatorsList &&
                              operatorsList.map((o, i) => (
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedOperator(o.OperatorName);
                                    setBillFetchError("");
                                    setInputFields([]);
                                    callInputFields(o.OurCode);
                                    setShowBill(false);
                                    handleOperatorSelection(e, o);
                                  }}
                                  type="button"
                                  class="dropdown-item"
                                >
                                  {o.OperatorName}
                                </a>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {selectedOperatorId === indaneGasOpCode ? (
                      indaneGas()
                    ) : selectedOperatorId === bharatGasOpCode ? (
                      getBharatGasFields()
                    ) : selectedOperatorId === hpGasOpCode ? (
                      getHPGasFields()
                    ) : (
                      <>
                        <div></div>
                      </>
                    )}

                    {operatorPaymentMode === 2 && amountField()}

                    {showBill && mobileNo && fetchBillSection()}

                    {mobileNo && showBillFetchError()}

                    <div class="col-md-12">
                      {!showBill && operatorPaymentMode !== 2 && (
                        <div class="mobile-recharge-btn">
                          {/* <button
                            onClick={!loading && clickFetchBill}
                            class="btn-primery"
                            id="addmoneymodal"
                          >
                            {loading ? <Loading /> : `Fetch Bill`}
                          </button> */}
                          <ThemeButton loading={loading} onClick={clickFetchBill} value={"Fetch Bill"}/>
                        </div>
                      )}
                      {operatorPaymentMode === 2 ||
                        (showBill && (
                          <div class="mobile-recharge-btn">
                            <ThemeButton onClick={onClickContinue} value={"Continue"}/>
                            {/* <button
                              onClick={onClickContinue}
                              class="btn-primery"
                              id="addmoneymodal"
                            >
                              {" "}
                              Continue{" "}
                            </button> */}
                          </div>
                        ))}
                    </div>
                  </div>
                </form>
              </div>
              {/* { </div>} */}
            </div>

            <div class="col-sm-12 col-md-12 col-lg-7 mobile-recharge-right-outer">
              <RecentHistory serviceId={lpgGasServiceId} />
            </div>

            <MuiSnackBar
              open={isSnackBar}
              setOpen={setIsSnackBar}
              successMsg={successMsg}
              errorMsg={errorMsg}
              setSuccess={setSuccessMsg}
              setError={setErrorMsg}
            />
          </div>
        </div>
      </section>
    </div>
  );

  return (
    <div className="color-body">
      {rechargeSection()}
    </div>
  );
};

export default LpgGasFront;
